export const reservasModals = {
  roomChange: {
    close: "Close",
    titleAssign: "Assign room",
    titleChange: "Change room",
    stopSoldNote:
      "This room type is closed for sale on these dates (stop-sell), but you can still reorganize the rooms: moving or assigning won't reopen sales.",
    labelAssign: "Room to assign",
    labelNew: "New room",
    selectPlaceholder: "Select a room…",
    swapWith: "Swap with {names}",
    swapWithType: "Swap with {names} (moves to {type})",
    swapTypeWarning: "After the swap, {names} moves to {type}, which is not the type they booked.",
    swapGroup:
      "Group swap: {name} and {also} move to that room, and {incoming} move to yours. All in a single operation.",
    swapSingle:
      "That room is occupied by {names}. On save they'll be {action}: your booking moves to that room and the other(s) move to yours.",
    swapWord: "swapped",
    emptyNote:
      "No room is free for the whole range. Use the {action} button on the «To organize» lane to rearrange bookings automatically.",
    organizeWord: "Organize",
    sameTypeGroup: "Same type · {name}",
    otherTypeGroup: "Other type · {name}",
    typeChangeNote:
      "The reservation will move to {type}. Its details are updated, both types have their availability recalculated and the channels are notified.",
    selectRoomError: "You must select a room",
    cancel: "Cancel",
    confirmSwap: "Swap",
    confirmAssign: "Assign",
    confirmSave: "Save change",
  },
  outOfOrder: {
    titleMaintenance: "Room maintenance",
    titleActions: "Room type actions",
    scopeLabel: "Scope",
    scopeUnit: "Room type (all)",
    scopeInstance: "This room",
    actionLabel: "Action",
    actionOoo: "Out of order (maintenance)",
    actionOpen: "Reopen in the range",
    quantityLabel: "Number of rooms",
    maxPerDay: "Up to {max} per day.",
    dateRangeLabel: "Date range",
    from: "From",
    to: "To",
    cancel: "Cancel",
    apply: "Apply",
  },
  closeDay: {
    title: "Change availability",
    syncing: "Syncing availability...",
    roomTypeLabel: "Room type",
    roomTypePlaceholder: "Select a room",
    startDate: "Start date",
    endDate: "End date",
    maxAvailable: "Maximum: {count} available",
    cancel: "Cancel",
    apply: "Apply change",
  },
  confirm: {
    defaultTitle: "Confirm?",
    confirm: "Confirm",
    cancel: "Cancel",
  },
  updateAlert: {
    title: "Update room",
    sectionTitle: "Room information",
    nameLabel: "Room name or number",
    keyLabel: "Access key",
    cancel: "Cancel",
    submit: "Update room",
    nameRequired: "The room name or number is required",
  },
};
